import { Component, Input } from '@angular/core';

@Component({selector: 'app-card-wrapper',
  templateUrl: './card-wrapper.component.html',
  styleUrls: ['./card-wrapper.component.scss'],
  standalone: false,
})
export class CardWrapperComponent {

  /** Content height */
  @Input() contentHeight: string = '200px';

  /** Card additional style */
  @Input() cardStyle: any;

  /** Direction */
  dir = document.dir;

}
